<div class="paginator">
  <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1" class="btnArrow">
    <fa-icon [icon]="faAngleLeft"></fa-icon>
  </button>

  <ng-container *ngFor="let page of getPages()">
    <button *ngIf="page !== '...'" 
            (click)="changePage(+page)" 
            [ngClass]="{'active': currentPage === page}">
      {{ page }}
    </button>
    <span *ngIf="page === '...'">...</span>
  </ng-container>
  

  <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages" class="btnArrow"> 
    <fa-icon [icon]="faAngleRight"></fa-icon>
  </button>
</div>
